import * as Mui from "@material-ui/core";
import React, { memo } from "react";
import { NavLink } from "react-router-dom";
import { IconHome } from "../svg";
import IconSeparator from "../svg/icon-separator";

const BreadcrumbContainer = memo((props) => {
  // const { t } = useTranslation();
  return (
    <>
      {/* <Mui.Typography
        component="h2"
        variant="h2"
        className="mb-2 font-weight-semi-bold"
      >
        {props?.title || ""}
      </Mui.Typography> */}

      <Mui.Breadcrumbs separator={
        <IconSeparator />
      } className="default-breadcrumbs mb-4">
        <Mui.Link
          className="ml-1"
          color="textSecondary"
          component={NavLink}
          to="/"
        >
          <IconHome />
        </Mui.Link>
        {props.paths.map((item, index) => {
          return (
            <Mui.Link
              key={index}
              color={
                index === props.paths.length - 1
                  ? "primary"
                  : "textSecondary"
              }
              underline={index === props.paths.length - 1 ? "none" : "hover"}
              component={index === props.paths.length - 1 ? null : NavLink}
              to={index === props.paths.length - 1 ? null : item.page}
            >
              {item?.title || ""}
            </Mui.Link>
          );
        })}
      </Mui.Breadcrumbs>
    </>
  );
});

BreadcrumbContainer.displayName = 'BreadcrumbContainer';
export default BreadcrumbContainer;
